const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeTwoTone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M4.03 21V4H8.03V7L16.03 3V9L20.03 13V21H12.03V14H8.03V21H4.03Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3654 2.67083C18.7359 2.48559 18.8861 2.03509 18.7008 1.6646C18.5156 1.29412 18.0651 1.14395 17.6946 1.32919L8.78 5.78649V3.25H3.28V8.53649L1.69459 9.32919C1.32411 9.51443 1.17394 9.96494 1.35918 10.3354C1.54442 10.7059 1.99493 10.8561 2.36541 10.6708L3.28 10.2135V20.25H2.03C1.61579 20.25 1.28 20.5858 1.28 21C1.28 21.4142 1.61579 21.75 2.03 21.75H3.28H16.78H22.03C22.4442 21.75 22.78 21.4142 22.78 21C22.78 20.5858 22.4442 20.25 22.03 20.25H20.78V14.8107L21.4997 15.5303C21.7926 15.8232 22.2674 15.8232 22.5603 15.5303C22.8532 15.2374 22.8532 14.7626 22.5603 14.4697L16.78 8.68934V3.46354L18.3654 2.67083ZM7.28 20.25H4.78V9.46354L15.28 4.21354V20.25H12.78V13.25H7.28V20.25ZM8.78 20.25H11.28V14.75H8.78V20.25ZM19.28 20.25H16.78V10.8107L19.28 13.3107V20.25ZM4.78 7.78649L7.28 6.53649V4.75H4.78V7.78649Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTwoTone);
export default __webpack_public_path__ + "static/media/HomeTwoTone.77a6bed57182409fbcfe8e910d359ad4.svg";
export { ForwardRef as ReactComponent };